import { css } from 'emotion';

export default {
    container: css`
        padding: 8px;
    `,
    topContainer: css`
        display: flex;
        align-items: center;
        flex-direction: row;
        position: relative;
        button {
            margin-left: 10px;
        }
        @media (max-width: 500px) {
            flex-direction: column;
            button {
                margin: 5px 0px;
            }
        }
    `,
    topContent: css`
        display: flex;
        flex: 1;
        justify-content: flex-end;
        @media (max-width: 500px) {
            flex-direction: column;
        }
    `,
    infoIcon: css`
        width: 12px;
        height: 12px;
        margin-right: 8px;
    `,
    readOnlyContainer: css`
        display: flex;
        flex: 1;
        justify-content: flex-end;
        align-items: center;
    `,
    readOnly: css`
        align-items: center;
        cursor: pointer;
        display: flex;
        margin-right: 5px;
        @media (max-width: 500px) {
            margin-right: 0px;
        }
    `,
    leftColumn: css`
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        @media (max-width: 500px) {
            flex-direction: column;
        }
    `,
    leftContentList: css`
        max-height: 800px;
        overflow-y: auto;
    `,
    rightContent: css`
        flex: 5;
    `,
    rowContainer: css`
        cursor: pointer;
        overflow-wrap: break-word;
    `,
    rowImage: css`
        text-align: center;
        width: 60px;
    `,
    rowNameText: css`
        font-weight: 600;
    `
};
